<template>
  <div
    :style="getPreviewThemeCss"
    :class="['FormQuestionsContainer Static', {'ReadOnly': readOnly}]"
  >
    <div
      class="BrandingImage"
      :class="{'Selected': headerImageSelected, 'HasImage': brandImageSrc !== null }"
      @click="handleHeaderImageSelect"
    >
      <div
        v-if="headerImageSelected"
        class="u-flex u-flex-spaceBetween"
      >
        <span
          class="QuestionUuid"
        >{{ selectedQuestion.key }}</span>
        <button
          v-if="brandImageSrc !== null"
          class="RemoveButton"
          @click="handleRemoveImage"
        >
          <span
            class="Icon-s Icon-trash"
          />
        </button>
      </div>
      <div :class="[{'Selected': headerImageSelected, 'HasImage': brandImageSrc !== null }, 'Question-container']">
        <div v-if="brandImageSrc === null">
          <span
            class="Icon Icon-image"
          />
          Add form header image(s)
        </div>
        <div v-else>
          <img
            :src="brandImageSrc"
            alt=""
          >
        </div>
      </div>
    </div>
    <draggable
      v-model="formQuestions"
      :class="[{'ReadOnly': readOnly}, 'FormBuilder list-group']"
      group="questions"
      :move="handleMove"
      draggable=".list-group-item"
    >
      <question-renderer
        v-for="(question, index) in questions"
        :key="`${question.question_uuid}_${index}`"
        :question="question"
        :show-replace-question="event.can_replace_questions"
        class="list-group-item"
        @question-renderer:select="handleSelectQuestion"
        @question-renderer:replace="handleReplaceQuestion"
      />
      <!--Vue draggable does not seem to like header and footer slots. Drag ordering becomes broken. Both elements are put in header slot deliverately.Slots must go after lists items! -->
      <template slot="header">
        <h2 class="FormQuestionsContainer-header u-text-center">
          Fill in the form below
        </h2>
        <div
          v-if="formQuestions.length === 0"
          class="NoQuestionsPlaceholder"
        >
          <span>Drag and drop a field from the categories to create a question</span>
        </div>
        <div
          v-else
          class="AddQuestionHint"
        >
          <span>Drag and drop a field from the categories to create a question</span>
        </div>
        <div
          class="SubmitButton"
          :class="{'Selected': submitButtonSelected }"
          @click="handleSubmitButtonSelect"
        >
          <span
            v-if="submitButtonSelected"
            class="QuestionUuid"
          >{{ selectedQuestion.key }}</span>
          <div :class="[{'Selected': submitButtonSelected }, 'Question-container u-text-center']">
            <button class="Button">
              {{ event.form_submit_text }}
            </button>
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>
<script>
import {
  mapState, mapMutations, mapGetters, mapActions,
} from 'vuex';
import Draggable from 'vuedraggable';
import QuestionRenderer from './static-question-renderer.vue';

export default {
  components: {
    Draggable,
    QuestionRenderer,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('events', {
      event: (state) => state.event,
    }),
    ...mapState('forms', {
      questions: (state) => state.form.questions,
      selectedQuestion: (state) => state.selectedQuestion,
    }),
    ...mapGetters('themes', ['getPreviewThemeCss']),
    // v-model for draggable component. Updated on drag and drop
    formQuestions: {
      get() { return this.questions; },
      set(questions) {
        this.setFormQuestions(questions);
      },
    },
    noQuestionSelected() {
      return this.selectedQuestion.index === undefined;
    },
    headerImageSelected() {
      return this.selectedQuestion.key === 'header_image';
    },
    submitButtonSelected() {
      return this.selectedQuestion.key === 'form_submit_text';
    },
    brandImageSrc() {
      if (Object.keys(this.event.media).length === 0) return null;
      if (this.event.media.banner !== null) {
        if (this.event.media.banner.is_displayed) {
          return this.event.media.banner.name;
        }
      }
      if (this.event.media.logo !== null) {
        if (this.event.media.logo.is_displayed) {
          return this.event.media.logo.name;
        }
      }
      return null;
    },
  },
  methods: {
    ...mapMutations('forms', [
      'updateSelectedQuestion',
      'setFormQuestions',
      'resetSelectedQuestion',
    ]),
    ...mapActions('forms', ['removeFormQuestion']),
    handleMove() {
      // Only allow drag reordering of questions when no question is selected (being edited)
      return this.noQuestionSelected;
    },
    handleSelectQuestion(question) {
      // Prevent the user from switching questions when another is open
      if (this.noQuestionSelected) this.updateSelectedQuestion(question);
    },
    handleReplaceQuestion(question) {
      this.$emit('web-form-renderer:replace', question);
    },
    handleRemoveImage() {
      if (this.event.media.banner !== null) {
        this.event.media.banner.is_displayed = false;
      }
      if (this.event.media.logo !== null) {
        this.event.media.logo.is_displayed = false;
      }
    },
    handleHeaderImageSelect() {
      // Prevent user from selecting a question when another is already open
      if (this.noQuestionSelected) {
        const headerImage = {
          non_question: true, key: 'header_image', media: this.event.media, question_uuid: 'form_submit_button', index: 1000,
        };

        this.updateSelectedQuestion(headerImage);
      }
    },
    handleSubmitButtonSelect() {
      if (this.noQuestionSelected) {
        const formButtonObject = {
          non_question: true, key: 'form_submit_text', question_uuid: 'form_submit_button', label: this.event.form_submit_text, index: this.questions.length,
        };

        this.updateSelectedQuestion(formButtonObject);
      }
    },
  },
};
</script>
